import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ActionTemporarilyDisabledTooltip = ({
  disabled,
  children
}) => /*#__PURE__*/_jsx(Tooltip, {
  placement: "bottom left",
  disabled: disabled,
  title: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "knowledgeContentUI.shared.actionTemporarilyDisabledTooltipText"
  }),
  children: children
});
export default ActionTemporarilyDisabledTooltip;